import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServicesStateService {
  private servicesSelectedSubject = new BehaviorSubject<boolean>(false);
  public servicesSelected$ = this.servicesSelectedSubject.asObservable();

  updateServicesState(hasServices: boolean) {
    this.servicesSelectedSubject.next(hasServices);
  }

  getCurrentState(): boolean {
    return this.servicesSelectedSubject.value;
  }
}
